// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-5561a8f7] .ag-input-field-select{color:#404040 !important;text-decoration:none !important;border:none;width:100%;height:100%}", ""]);
// Exports
module.exports = exports;
